var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar',{attrs:{"toggleIcon":"arrow_back"},on:{"toggleAction":function($event){return _vm.$router.back()}}}),_c('h1',[_vm._v("Página de Busca")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }